import { createFileRoute, redirect } from '@tanstack/react-router';
import { SuperAdminPrivacyRequests } from '@/components/super-admin/privacy-requests';

export const Route = createFileRoute(
  '/_auth/_side-layout/super-admin/privacy-requests',
)({
  component: SuperAdminPrivacyRequestsPage,
  beforeLoad: async ({ context }) => {
    if (context.platformRole !== 'admin') {
      throw redirect({ to: '/' });
    }
  },
});

function SuperAdminPrivacyRequestsPage() {
  return <SuperAdminPrivacyRequests />;
}
